module.exports = __webpack_public_path__ + "img/file-medical-fill.c5322f49.svg";